<template>
  <div id="Finish__form">
    <a-result
      status="success"
      :title="`Successfully! ${FormData.TITLE} ${FormData.result.type}.`"
      :sub-title="`${$t('Company')} ID: ${FormData.result.id}, ${$t('data saved to')} ${FormData.result.saveTo}`"
    >
      <template #extra>
        <a
          :href="`https://${Auth.domain}/crm/company/details/${FormData.result.id}/`"
          target="_blank"
        >
          <a-button>{{$t('Go to company')}}</a-button>
        </a>
        <a-button type="primary" @click="handlerOk">{{$t('Close')}}</a-button>
      </template>
      <div class="desc">
        <p style="font-size: 16px;">
          <strong>{{$t('The content you submitted for company')}}:</strong>
        </p>
        <span v-if="saveCompanyTypeNip.Fields">
          <p v-for="(value, key) in settingsNip" :key="key">
            <a-icon :style="{ color: 'green' }" type="check-circle" />
            {{value.name}}
            <a-icon type="arrow-right" />
            {{FormData[value.id]}}
          </p>
        </span>
        <span v-else>
          <p v-for="(value, key) in settingsNip" :key="key">
            <a-icon :style="{ color: 'green' }" type="check-circle" />
            {{key}}
            <a-icon type="arrow-right" />
            {{FormData[key]}}
          </p>
        </span>
      </div>
    </a-result>
    <h4 style="text-align:center">
      {{$t('Do not see new fields in the Company?')}}
      <a
        href="https://my.support.pl/index.php?rp=/knowledgebase/156/Praca-z-polami-na-karcie-CRM.html"
        target="_blank"
        style="text-decoration: none;"
      >{{$t('Edit the Company view')}}</a>
    </h4>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  mounted() {
    this.resizeWindow();
  },
  computed: mapGetters([
    "FormData",
    "settingsNip",
    "saveCompanyTypeNip",
    "Auth",
  ]),
  methods: {
    ...mapActions(["NextStep", "PrevStep", "resizeWindow", "changeSpinning"]),
    handlerOk() {
      this.changeSpinning();
      this.$emit("handlerClose");
    },
  },
};
</script>

<style scoped>
</style>
